import {createQueryKeys} from "../../shared/query/query-keys";

export const clientKeys = createQueryKeys("clients");

export const clientMutationKeys = {
  updateClient: ["clients", "mutation", "update-client"] as const,
  deleteClient: ["clients", "mutation", "delete-client"] as const,
  restoreClient: ["clients", "mutation", "restore-client"] as const,
  addClientContact: ["clients", "mutation", "add-client-contact"] as const,
  editClientContact: ["clients", "mutation", "edit-client-contact"] as const,
  removeClientContact: ["clients", "mutation", "remove-client-contact"] as const,
  addClientNote: ["clients", "mutation", "add-client-note"] as const,
  editClientNote: ["clients", "mutation", "edit-client-note"] as const,
  removeClientNote: ["clients", "mutation", "remove-client-note"] as const,
} as const;
